import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../../../../auth/src/auth.service';
import { ModalComponent } from '../../../../share/components/modal/modal.component';

@Component({
  selector: 'app-reset-pwd',
  templateUrl: './reset-pwd.component.html',
  styleUrls: ['../login-page/login-page.component.scss'],
  imports: [ReactiveFormsModule, NgxBootstrapIconsModule],
})
export class ResetPwdComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);
  private formBuilder = inject(FormBuilder);
  private modalService = inject(NgbModal);

  resetPwdForm: FormGroup | undefined;
  userToken: string | null | undefined;
  showPassword = false;
  showConfirmPassword = false;

  get password() {
    return this.resetPwdForm?.get('password');
  }
  get confirmPassword() {
    return this.resetPwdForm?.get('confirmPassword');
  }
  ngOnInit() {
    this.userToken = this.activatedRoute.snapshot.paramMap.get('userToken');
    this.resetPwdForm = this.formBuilder.group({
      password: new FormControl('', Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9@$!%*?&]).{12,}$')),
      confirmPassword: new FormControl(''),
    });
  }

  onSubmit() {
    if (this.userToken) {
      this.authService.initializePassword(this.resetPwdForm?.value.password, this.userToken).subscribe({
        next: async () => {
          localStorage.removeItem('token');
          const modalRef = this.modalService.open(ModalComponent);
          modalRef.componentInstance.type = 'success';
          modalRef.componentInstance.header = 'Réinitialisation mot de passe';
          modalRef.componentInstance.message =
            'Votre mot de passe a bien été réinitialisé. <br> Vous allez être redirigé vers la page de connexion.';
          await modalRef.result.then(() => this.router.navigate(['/']));
        },
        error: (err) => {
          const modalRef = this.modalService.open(ModalComponent);
          modalRef.componentInstance.type = 'danger';
          modalRef.componentInstance.header = 'Erreur de réinitialisation du mot de passe';
          modalRef.componentInstance.message = err.error
            ? err.error.message
            : 'Il y a eu une erreur lors de la réinitialisation de votre mot de passe. <br> Veuillez réessayer ou contacter un administrateur. <br> Désolé pour la gêne occasionnée.';
        },
      });
    }
  }
}
